import { Canvas2DContext } from './draw-helpers';

// ctx.roundRect есть не во всех поддерживаемых браузерах (Firefox < 112)
export const fillRoundRect = (
    ctx: Canvas2DContext,
    x: number,
    y: number,
    width: number,
    height: number,
    radius: number
) => {
    ctx.beginPath();

    if (typeof ctx.roundRect === 'function') {
        ctx.roundRect(x, y, width, height, radius);
    } else {
        const r = Math.min(radius, width / 2, height / 2);

        ctx.moveTo(x + r, y);
        ctx.arcTo(x + width, y, x + width, y + height, r);
        ctx.arcTo(x + width, y + height, x, y + height, r);
        ctx.arcTo(x, y + height, x, y, r);
        ctx.arcTo(x, y, x + width, y, r);
        ctx.closePath();
    }

    ctx.fill();
};
